import React, { useEffect, useState } from 'react';
import { Button, Input, Dropdown } from '../../Atoms';
import { ValidatorForm } from 'react-form-validator-core';
import {
  getInvites,
  reset,
  sendInvite,
} from '../../redux/actions/ManagerAction';
import { connect } from 'react-redux';
import useToaster from '../Toaster/useToaster';

const InviteTeamForm = ({
  sendInvite: { loading, error, success },
  send,
  getAllInvites,
  userInfo: { role },
  reset,
}) => {
  const { toast } = useToaster();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    role: '',
  });

  const handleSubmit = () => {
    const payload = {
      email: formData.email,
      role: formData.role,
    };
    const host = window.location.origin;
    if (formData.firstName) payload.first_name = formData.firstName;
    if (formData.lastName) payload.last_name = formData.lastName;
    payload.accept_invitation_url = `${host}/welcome`;
    send(payload);
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData({ ...formData, [name]: value });
  };

  const getOptions = () => {
    let options = [
      { title: 'Manager', value: 'manager' },
      { title: 'Employee', value: 'employee' },
    ];

    if (role === 'clevel') {
      options = [...options, { title: 'CLevel', value: 'clevel' }];
    }

    return options;
  };

  useEffect(() => {
    if (success) {
      const name = `${formData.firstName} ${formData.lastName}`.trim();
      toast({
        text: `${name} has been invited.`,
      });
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
      });
      reset('sendInvite');
      // getAllInvites();
    }

    if (error) {
      toast({
        text: error,
        type: 'error',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error]);

  return (
    <div className="invite-team-form">
      <div className="heading">Invite Team Members</div>
      <div className="description">
        Enter your team members below to add them to your team. Once added to
        your team, PEAKmind will email the user an invite for them to sign up.
      </div>
      <ValidatorForm onSubmit={handleSubmit} className="form">
        <Input
          title="Team Member First Name"
          name="firstName"
          value={formData.firstName}
          formValid={true}
          onChange={handleChange}
          validators={['maxStringLength:30']}
          errorMessages={['First Name must be less than 30 character']}
          fullWidth
        />
        <Input
          title="Team Member Last Name"
          name="lastName"
          value={formData.lastName}
          formValid={true}
          onChange={handleChange}
          validators={['maxStringLength:30']}
          errorMessages={['Last Name must be less than 30 character']}
          fullWidth
        />
        <Input
          title="Email"
          name="email"
          value={formData.email}
          formValid={!error}
          onChange={handleChange}
          validators={['required', 'isEmail']}
          errorMessages={['this field is required', 'email is not valid']}
          fullWidth
        />
        <Dropdown
          title="Company Role"
          options={getOptions()}
          value={formData.role}
          onChange={handleChange}
          name="role"
        />
        <div className="action-wrapper">
          <Button size="lg" color="blue" loading={loading}>
            Invite team member
          </Button>
        </div>
      </ValidatorForm>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sendInvite: state.manager.sendInvite,
  userInfo: state.auth.userInfo.info || {},
});

const mapDispatchToProps = (dispatch) => ({
  send: (details) => {
    dispatch(sendInvite(details));
  },
  getAllInvites: () => {
    dispatch(getInvites());
  },
  reset: (block) => {
    dispatch(reset(block));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteTeamForm);
